import { MouseEvent, useState } from 'react';

interface ExpandableRowProps {
  allowMultiple?: boolean;
}

export function useRowExpand({ allowMultiple = true }: ExpandableRowProps = {}) {
  const [expandedRowKeys, setExpandedRowKeys] = useState<string[]>([]);

  const handleExpand = (key: string, event: MouseEvent, expandable: boolean = true) => {
    if (!expandable) {
      return;
    }
    event?.stopPropagation();

    if (allowMultiple) {
      const newExpandedRowKeys = expandedRowKeys.includes(key) ? expandedRowKeys.filter((key) => key !== key) : [...expandedRowKeys, key];
      return setExpandedRowKeys(newExpandedRowKeys);
    }

    setExpandedRowKeys(expandedRowKeys.includes(key) ? [] : [key]);
  };

  return {
    expandedRowKeys,
    handleExpand,
    setExpandedRowKeys,
  };
}
